import { VideoPanel } from './VideoPanel';

export * from './VideoPanel';
export default VideoPanel;
